module.exports = __webpack_public_path__ + "static/img/-s-2.339bd44.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/-s-2.png
// module id = Uuwn
// module chunks = 0